import React from 'react';
import {type AstView} from 'rendition-core';

import PreviewContext from 'Contexts/PreviewContext';
import {RichPreview} from '../RichPreview';

interface Props {
    view: AstView;
    setView: (view: AstView) => void;
    saveView: () => void;
}

// This is similar to [Grouping], but it is not interactive.
// It is used to show the user what the final result will look like.
// It also allows text selection in the nodes, which is not possible in the interactive version,
// due to the way the nodes are allowed to be selected/dragged.
export const UninteractiveRegrouping: React.FC<React.PropsWithChildren<Props>> = ({view, setView}) => {
    return (
        <div className="flex min-h-screen w-full flex-row items-stretch justify-between">
            <PreviewContext
                value={{
                    view,
                    translucentNodes: [],
                    onNodeClick: () => false,
                    onNodeMouseEnter: () => true,
                    onNodeMouseLeave: () => false,
                    unclickableNodes: [],
                    setUnclickableNodes: () => {},
                    hiddenNodes: [],
                }}
            >
                <RichPreview forceFixedSizing={false} view={view} isUserSelectable={true} />
            </PreviewContext>
        </div>
    );
};
